// extracted by mini-css-extract-plugin
export default {"footer_container":"Footer_footer_container__-qntc","footer":"Footer_footer__FDfaH","row":"Footer_row__uIZ9B","gitLogo":"Footer_gitLogo__b15Mw"};